export default [
  {
    name: 'nfes',
    path: '/nfes',
    component: () => import(/* webpackChunkName: "dfes" */ './Nfes')
  },
  {
    name: 'nfces',
    path: '/nfces',
    component: () => import(/* webpackChunkName: "dfes" */ './Nfces')
  },
  {
    name: 'cfes',
    path: '/cfes',
    component: () => import(/* webpackChunkName: "dfes" */ './Cfes')
  },
  {
    name: 'ctes',
    path: '/ctes',
    component: () => import(/* webpackChunkName: "dfes" */ './Ctes')
  },
  {
    name: 'nfses',
    path: '/nfses',
    component: () => import(/* webpackChunkName: "dfes" */ './Nfses')
  }
]
